import { render, staticRenderFns } from "./ReturnsPolicyModal.vue?vue&type=template&id=7e70fcf8&scoped=true&"
import script from "./ReturnsPolicyModal.vue?vue&type=script&lang=ts&"
export * from "./ReturnsPolicyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnsPolicyModal.vue?vue&type=style&index=0&id=7e70fcf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e70fcf8",
  null
  
)

export default component.exports